// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { rj } from "../../assets.jsx";
import { dj } from "../../assets.jsx";
import { fj } from "../../assets.jsx";
import { hj } from "../../assets.jsx";
import { mj } from "../../assets.jsx";
import { pj } from "../../assets.jsx";
import { vj } from "../../assets.jsx";
import { bj } from "../../assets.jsx";
import { gj } from "../../assets.jsx";
import { yj } from "../../assets.jsx";
import { _j } from "../../assets.jsx";
import { jj } from "../../assets.jsx";
import { xj } from "../../assets.jsx";
import { Sj } from "../../assets.jsx";
import { wj } from "../../assets.jsx";
import { Nj } from "../../assets.jsx";
import { Tj } from "../../assets.jsx";
import { Cj } from "../../assets.jsx";
import { Mj } from "../../assets.jsx";
import { Aj } from "../../assets.jsx";
import { Ej } from "../../assets.jsx";
import { Dj } from "../../assets.jsx";
import { zj } from "../../assets.jsx";
import { Oj } from "../../assets.jsx";
import { kj } from "../../assets.jsx";
import { Rj } from "../../assets.jsx";
import { Bj } from "../../assets.jsx";
import { Uj } from "../../assets.jsx";
import { Hj } from "../../assets.jsx";
import { Lj } from "../../assets.jsx";
import { qj } from "../../assets.jsx";
import { Gj } from "../../assets.jsx";
import { Yj } from "../../assets.jsx";
import { Xj } from "../../assets.jsx";
import { Qj } from "../../assets.jsx";
import { Zj } from "../../assets.jsx";
import { Vj } from "../../assets.jsx";
import { $j } from "../../assets.jsx";
import { Kj } from "../../assets.jsx";
import { Jj } from "../../assets.jsx";
import { Wj } from "../../assets.jsx";
import { Ij } from "../../assets.jsx";
import { Fj } from "../../assets.jsx";
import { Pj } from "../../assets.jsx";
import { ex } from "../../assets.jsx";
import { tx } from "../../assets.jsx";
import { ax } from "../../assets.jsx";
import { lx } from "../../assets.jsx";
import { nx } from "../../assets.jsx";
import { sx } from "../../assets.jsx";
import { ix } from "../../assets.jsx";
import { cx } from "../../assets.jsx";
import { ux } from "../../assets.jsx";
import { ox } from "../../assets.jsx";
import { rx } from "../../assets.jsx";
import { dx } from "../../assets.jsx";
import { fx } from "../../assets.jsx";
import { hx } from "../../assets.jsx";
import { mx } from "../../assets.jsx";
import { px } from "../../assets.jsx";
import { vx } from "../../assets.jsx";
export const Sm = Object.assign({
  "../../assets/universes/Attack_on_Titan.webp": rj,
  "../../assets/universes/Baki.webp": dj,
  "../../assets/universes/Berserk.webp": fj,
  "../../assets/universes/Black_Clover.webp": hj,
  "../../assets/universes/Bleach.webp": mj,
  "../../assets/universes/Blue_Lock.webp": pj,
  "../../assets/universes/Chainsaw_Man.webp": vj,
  "../../assets/universes/Classroom_of_the_Elite.webp": bj,
  "../../assets/universes/Code_Geass.webp": gj,
  "../../assets/universes/Death_Note.webp": yj,
  "../../assets/universes/Demon_Slayer.webp": _j,
  "../../assets/universes/DrStone.webp": jj,
  "../../assets/universes/Dragon_Ball.webp": xj,
  "../../assets/universes/DxD.webp": Sj,
  "../../assets/universes/Evangelion.webp": wj,
  "../../assets/universes/Fairy_Tail.webp": Nj,
  "../../assets/universes/Fate.webp": Tj,
  "../../assets/universes/Fire_Force.webp": Cj,
  "../../assets/universes/First_Step.webp": Mj,
  "../../assets/universes/Frieren.webp": Aj,
  "../../assets/universes/Fullmetal_Alchemist.webp": Ej,
  "../../assets/universes/Gachiakuta.webp": Dj,
  "../../assets/universes/Goblin_Slayer.webp": zj,
  "../../assets/universes/Grand_Blue.webp": Oj,
  "../../assets/universes/Gurren_Lagann.webp": kj,
  "../../assets/universes/Hells_Paradise.webp": Rj,
  "../../assets/universes/Hellsing.webp": Bj,
  "../../assets/universes/Hunter_x_Hunter.webp": Uj,
  "../../assets/universes/JnR.webp": Hj,
  "../../assets/universes/JoJo.webp": Lj,
  "../../assets/universes/Jobless_Reincarnation.webp": qj,
  "../../assets/universes/Jujutsu_Kaisen.webp": Gj,
  "../../assets/universes/Kaiju.webp": Yj,
  "../../assets/universes/Kakegurui.webp": Xj,
  "../../assets/universes/Kenshin.webp": Qj,
  "../../assets/universes/Kuroko_no_Basuke.webp": Zj,
  "../../assets/universes/MDUD.webp": Vj,
  "../../assets/universes/MHA.webp": $j,
  "../../assets/universes/Mob_Psycho_100.webp": Kj,
  "../../assets/universes/Monster.webp": Jj,
  "../../assets/universes/Multiverse.webp": Wj,
  "../../assets/universes/Naruto.webp": Ij,
  "../../assets/universes/One_Piece.webp": Fj,
  "../../assets/universes/OshinoKo.webp": Pj,
  "../../assets/universes/ReZero.webp": ex,
  "../../assets/universes/RoR.webp": tx,
  "../../assets/universes/SAO.webp": ax,
  "../../assets/universes/Solo_Leveling.webp": lx,
  "../../assets/universes/Soul_Eater.webp": nx,
  "../../assets/universes/TQQ.webp": sx,
  "../../assets/universes/Tensei_Shitara_Slime_Datta_Ken.webp": ix,
  "../../assets/universes/The_Eminence_in_Shadow.webp": cx,
  "../../assets/universes/The_Seven_Deadly_Sins.webp": ux,
  "../../assets/universes/Tokyo_Ghoul.webp": ox,
  "../../assets/universes/Tokyo_Revengers.webp": rx,
  "../../assets/universes/Tomodachi_Game.webp": dx,
  "../../assets/universes/Tower_of_God.webp": fx,
  "../../assets/universes/Vagabond.webp": hx,
  "../../assets/universes/Vinland_Saga.webp": mx,
  "../../assets/universes/onepunchman.webp": px,
  "../../assets/universes/Волейбол.webp": vx
});
export function universeArtwork(u) {
  return Sm[`../../assets/universes/${u}.webp`] || Sm["../../assets/universes/Multiverse.webp"];
}
export function preloadUniverseImage(u) {
  return new Promise(o => {
    const m = new Image();
    m.decoding = "async";
    let r = !1;
    const g = () => {
        r || (r = !0, window.clearTimeout(j), m.onload = null, m.onerror = null, o());
      },
      j = window.setTimeout(g, 5e3);
    m.onload = () => {
      m.decode().catch(() => {}).then(g);
    }, m.onerror = g, m.src = u;
  });
}
export async function preloadUniverseArtwork(u, o) {
  const m = [...new Set([u, ...o.map(r => r.key)].map(universeArtwork))];
  await Promise.all(m.slice(0, 6).map(preloadUniverseImage)), (async () => {
    for (let r = 6; r < m.length; r += 3) await Promise.all(m.slice(r, r + 3).map(preloadUniverseImage));
  })();
}
